import { showNotification } from "~/ui";

/**
 * Timeout length selected based on average age of user base to allow
 * for a longer than usual timeout (3-5 seconds)
 */
const _toastTimeout = 8000;

interface NotificationArgsBase<T> {
  message?: string | ((response: T) => string);
  title: string | ((response: T) => string);
}
/**
 * Generate a standard Mantine notification on mutation error
 */
export const onErrorNotification =
  <T>(args: NotificationArgsBase<T>) =>
  (error: T) => {
    const title = typeof args.title === "function" ? args.title(error) : "Something went wrong";
    const message =
      typeof args.message === "function"
        ? args.message(error)
        : (args.message ?? (error instanceof Error ? error.message : "An unexpected error occurred"));

    showNotification({
      title,
      message,
      color: "red",
    });
  };

export const onSuccessNotification =
  <T>(args: NotificationArgsBase<T>, cb?: (input: T) => void) =>
  (response: T) => {
    const title = typeof args.title === "function" ? args.title(response) : args.title;
    const message = typeof args.message === "function" ? args.message(response) : args.message;

    showNotification({
      title,
      message,
      color: "green",
      autoClose: _toastTimeout,
    });

    if (!!cb) {
      cb(response);
    }
  };

interface OnSuccessFileDownloadArgs {
  url: string;
}
/**
 * Consume a standardized url response and download the file using
 * the returned URL
 */
export const onSuccessFileDownload = (args: OnSuccessFileDownloadArgs) => {
  const win = window.open(args.url, "_blank", "noopener,noreferrer");
  if (win) {
    win.opener = null;
  }
};
